module.exports = __webpack_public_path__ + "static/img/RSG2-12V20A.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/front/RSG2-12V20A.png
// module id = VQ0F
// module chunks = 0